export default [
  { key: "no", label: "ลำดับที่", sortable: true , thStyle:{color:"white",width: "6% !important"}},
  {
    key: "serial",
    label: "Serial No.",
    thStyle:{color:"white"}
  },  
  {
    key: "hwTypeName",
    label: "Hardware type",
    thStyle:{color:"white"}
  }, 
  {
    key: "hwBrandName",
    label: "Brand",
    thStyle:{color:"white"}
  },
  {
    key: "hwModelName",
    label: "Model",
    thStyle:{color:"white"}
  }, 
  {
    key: "description",
    label: "รายละเอียด",
    thStyle:{color:"white"}
  }, 
  {
    key: "status",
    label: "สถานะ",
    thStyle:{color:"white",width: "8% !important", textAlign: "center",}
  }, 
  { 
    key: "action",
    label: "จัดการ",
    sortable: false,
    thStyle: { width: "12% !important", textAlign: "center", color:"white" },
  },
];
